import { Injectable, Injector } from "@angular/core";
import { NotificationAbstract } from "../models/notification-abstract";
import { ENotificationType } from "../enums/e-notification-type";
import { NotificationReminderSession } from "../models/notification-reminder-session";

@Injectable({
  providedIn: 'root'
})
export class NotificationFactory {
    
    constructor(private injector : Injector){

    }

  create(notification : NotificationAbstract) : NotificationAbstract {

      let obj = null;

      if(notification.type == ENotificationType.ReminderSession){
          obj = new NotificationReminderSession(this.injector);
      }else{
          throw new Error("No notification for this type !");
      }
      
      return this.fillObject(obj, notification);
  }

  createInstance(type : ENotificationType) : NotificationAbstract {

    let obj = null;

    if(type == ENotificationType.ReminderSession){
        obj = new NotificationReminderSession(this.injector);
    }else{
        throw new Error("No notification for this type !");
    }

    return obj;
  }

  private fillObject(notification : any, object : any){

      for (const [key, value] of Object.entries(object)) {
          if(notification.hasOwnProperty(key)){
            notification[key] = value;
          }
      }

      return notification;
  }
}

